<template>
  <div>
    <sc-dropdown
      class="card-dropdown"
      aria-role="list"
      position="is-bottom-left"
    >
      <button type="button" class="card-menu-button" slot="trigger">
        <sc-icon icon="ellipsis-v"></sc-icon>
      </button>

      <sc-dropdown-item
        class="card-dropdown-item"
        :disabled="!this.integration.installed"
        @click="() => handleEditIntegrationButton()"
      >
        <span> <sc-icon icon="pen"></sc-icon> Editar </span>
      </sc-dropdown-item>

      <sc-dropdown-item
        class="card-dropdown-item"
        :disabled="!this.integration.installed"
        @click="() => handleMonitoringIntegrationButton()"
      >
        <span> <sc-icon icon="heartbeat"></sc-icon> Monitorar </span>
      </sc-dropdown-item>

      <sc-dropdown-item
        class="card-dropdown-item"
        :disabled="!this.integration.installed"
        @click="() => handleUninstallButton()"
      >
        <span> <sc-icon icon="times"></sc-icon> Desinstalar </span>
      </sc-dropdown-item>

      <sc-dropdown-item
        class="card-dropdown-item"
        @click="() => handleAboutIntegrationButton()"
      >
        <span> <sc-icon icon="info"></sc-icon> Sobre </span>
      </sc-dropdown-item>

      <sc-dropdown-item
        class="card-dropdown-item"
        @click="() => handleReportProblemIntegrationButton()"
      >
        <span>
          <sc-icon icon="skull-crossbones"></sc-icon> Reportar problema
        </span>
      </sc-dropdown-item>
    </sc-dropdown>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  ScButton,
  ScIcon,
  ScDropdown,
  ScDropdownItem,
  ScToast,
  ScDialog,
} from "@intelipost-js/secure-components";
import AboutButton from "./about-button/AboutButton.vue";
import EditButton from "./edit-button/EditButton.vue";
import MonitorButton from "./monitor-button/MonitorButton.vue";
import ReportProblemButton from "./report-problem-button/ReportProblemButton.vue";
import UninstallButton from "./uninstall-button/UninstallButton.vue";

const { mapActions } = createNamespacedHelpers("integrations/integrationsHome");

export default {
  name: "iplink-app-card-header-menu",

  props: {
    integration: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions([
      "getAppList",
      "uninstallIntegrationAction",
      "selectAppAction",
      "showAboutModalAction",
      "showEditModalAction",
      "showReportProblemModalAction",
      "getAppById",
    ]),

    handleAboutIntegrationButton() {
      this.selectAppAction(this.integration);
      this.showAboutModalAction(true);
    },

    handleEditIntegrationButton() {
      this.selectAppAction(this.integration);
      this.getAppById(this.integration.id);
      this.showEditModalAction(true);
    },

    handleMonitoringIntegrationButton() {
      return ScToast.danger("A função Monitorar ainda não está habilitada. =(");
    },

    handleReportProblemIntegrationButton() {
      this.showReportProblemModalAction(true);
    },

    handleUninstallButton() {
      return ScDialog.confirm({
        title: "Confirmação de desinstalação",
        message: `Você tem certeza que deseja desinstalar o aplicativo <b>${this.integration.name}</b>?`,
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        onConfirm: () =>
          this.uninstallIntegrationAction(
            this.integration.installation_id
          ).then(({ ok, message }) => {
            if (ok) {
              this.getAppList();

              return ScToast.success("Aplicativo desinstalado com sucesso");
            }
              return ScToast.open({message, duration: 20000, type: 'is-danger'});
          }),
      });
    },

  },

  components: {
    ScButton,
    ScIcon,
    ScDropdown,
    ScDropdownItem,
    ScToast,
    ScDialog,
    AboutButton,
    EditButton,
    MonitorButton,
    ReportProblemButton,
    UninstallButton,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {
  .card-header-button {
    background: none;
    border: none;
  }

  .card-menu-button {
    border: none;
    background-color: white;
    margin: 1rem 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/app-list/app-card/header-card/menu-card/MenuCard.vue